import React from "react";
import {
  SEO,
  PageLayout,
  DynamicTiles,
  MultipleComponentIterator,
  FadeReveal,
  FullImageCard,
  InternalLink,
  FishermanIcon,
  MarkdownContent,
  WebsiteComponentInteractions,
  Image,
  BasicCarousel,
  multipleComponentIterator,
  SlideReveal,
  BackgroundImageTeamMember,
  SocialMediaV2,
  componentIterator,
  Conditional,
  LocationName,
  ReviewV2,
  CustomerReviewModal,
  HorizontalImageCard,
  BlogPostLink,
  FormattedDate,
  ExpandableText,
} from "@bluefin/components";
import { Button, Grid, Header, Card } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
  getComponentInteractions,
  withNamedArgs,
  getBusinessFiles,
} from "../utils/utils";
import {
  createTeamMemberSlug,
  createLocationSlug,
} from "@bluefin/gatsby-plugin-fisherman-page-creator";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      dynamicTilesComponent,
      allFishermanBusinessTeam,
      allFishermanBusinessLocation,
      allFishermanBusinessFile,
      allFishermanBusinessBlogPost,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          title={fishermanBusinessWebsitePage.seoTitle}
          ogImage={fishermanBusinessWebsitePage.seoOgImage}
          ogUrl={"https://www.curlevolution.com/"}
        />
        <PageLayout hero={false} subfooter={false} className={"home-page"}>
          <DynamicTiles className={"custom-hero"}>
            <MultipleComponentIterator
              iterator={dynamicTilesComponent.childConfigurations}
              components={[
                {
                  component: (
                    <DynamicTiles.Tile imageProps={{ loadStrategy: "eager" }} />
                  ),
                  propMap: {
                    images: "files",
                    content: "contentNodes",
                    interactions: "interactions",
                    className: "data.className",
                    overlayClassName: "data.overlayClassName",
                    width: "data.width",
                    video: "data.video",
                  },
                },
              ]}
            />
          </DynamicTiles>
          <div className={"services-section"}>
            <Card.Group className={"services"} itemsPerRow={3} stackable={true}>
              <FadeReveal
                cascade={true}
                cascadeFactor={0.4}
                triggerOnce={true}
                className={"ui card"}
                disableAnimationOnMobile={true}
                noContainer={true}
              >
                <FullImageCard
                  link={true}
                  image={
                    "https://fisherman.gumlet.io/public/a99e7c11-b5b1-499a-bba7-eeb4cb1b4bdb/291A7399.jpg"
                  }
                  as={InternalLink}
                  to={"https://phorest.com/book/salons/curlevolution"}
                >
                  <Card.Header content={"Book Services"} />
                  <FishermanIcon iconName={"arrow-right"} />
                </FullImageCard>
                <FullImageCard
                  link={true}
                  image={
                    "https://fisherman.gumlet.io/public/a99e7c11-b5b1-499a-bba7-eeb4cb1b4bdb/custom_thumbnail_large_2.png"
                  }
                  as={InternalLink}
                  to={"/products/"}
                >
                  <Card.Header content={"Juicy Curls"} />
                  <FishermanIcon iconName={"arrow-right"} />
                </FullImageCard>
                <FullImageCard
                  link={true}
                  image={
                    "https://fisherman.gumlet.io/public/a99e7c11-b5b1-499a-bba7-eeb4cb1b4bdb/custom_thumbnail_large_3.png"
                  }
                  as={InternalLink}
                  to={"/services"}
                >
                  <Card.Header content={"Curl Evolution Method™"} />
                  <FishermanIcon iconName={"arrow-right"} />
                </FullImageCard>
              </FadeReveal>
            </Card.Group>
            <Button
              primary={true}
              to={"/services/"}
              event={{ category: "Services", action: "View All Services" }}
              as={InternalLink}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "see_all_services_button",
                defaultValue: "See All Services",
              })}
            />
            <h4>
              Expert curly cuts and personalized styling lessons that help you
              take control of your curls
            </h4>
          </div>
          <div className={"about-section"}>
            <Grid stackable={true} doubling={true} columns={2}>
              <Grid.Column width={8} className={"markdown-column"}>
                <FadeReveal duration={1250} triggerOnce={true}>
                  <MarkdownContent
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "about_section_description",
                    })}
                  />
                  <WebsiteComponentInteractions
                    ctas={getComponentInteractions({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "about_section_description",
                    })}
                  />
                </FadeReveal>
              </Grid.Column>
              <Grid.Column width={8} className={"image-column"}>
                <FadeReveal duration={1250} triggerOnce={true} delay={450}>
                  <Image
                    className={"image"}
                    src={getComponentFiles({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "Content.Image",
                      componentIdentifier: "about_section_image",
                      numToSelect: 1,
                    })}
                  />
                </FadeReveal>
              </Grid.Column>
            </Grid>
          </div>
          <div className={"stylists-section"}>
            <Header
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "staff_section_header",
                defaultValue: "OUR TEAM",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "staff_section_description",
              })}
            />
            <BasicCarousel
              className={"featured-stylists"}
              size={3}
              displayIndicators={false}
              displayPlayPauseButton={true}
              autoScroll={true}
              slide={true}
              items={multipleComponentIterator({
                iterator: allFishermanBusinessTeam.nodes,
                components: [
                  {
                    component: (
                      <SlideReveal
                        className={"ui card"}
                        fade={true}
                        direction={"up"}
                        triggerOnce={true}
                      />
                    ),
                    propMap: { key: "_id" },
                    children: [
                      {
                        component: (
                          <BackgroundImageTeamMember
                            useModal={false}
                            as={InternalLink}
                          />
                        ),
                        propMap: {
                          "teamMember.name": "name",
                          "teamMember.role": "role",
                          "teamMember.photo": "gatsbyImage",
                          "teamMember.description": "description",
                          "teamMember.email": "email",
                          "teamMember.phone": "phone",
                          "teamMember.locations": "locations",
                          "teamMember.hours": "hours",
                          to: createTeamMemberSlug,
                        },
                      },
                    ],
                  },
                ],
              })}
            />
            <WebsiteComponentInteractions
              alignment={"center"}
              ctas={getComponentInteractions({
                components: fishermanBusinessWebsitePage.components,
                componentId: "staff_section_description",
              })}
              fallback={
                <React.Fragment>
                  <Button
                    to={"/team/"}
                    primary={true}
                    event={{
                      category: "Team",
                      action: "View All Team Members",
                    }}
                    as={InternalLink}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "see_all_team_button",
                      defaultValue: "See Our Team",
                    })}
                  />
                </React.Fragment>
              }
            />
          </div>
          <div className={"image-gallery-section"}>
            <Header
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "image_section_header",
                defaultValue: "WE'RE SOCIAL",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "image_section_description",
              })}
            />
            <WebsiteComponentInteractions
              alignment={"center"}
              ctas={getComponentInteractions({
                components: fishermanBusinessWebsitePage.components,
                componentId: "image_section_description",
              })}
            />
            <SocialMediaV2>
              <MultipleComponentIterator
                iterator={fishermanBusiness.socialMedia}
                components={[
                  {
                    component: <SocialMediaV2.Platform />,
                    propMap: { key: "_id", url: "link", platform: "type" },
                    children: [
                      {
                        component: <SocialMediaV2.Icon />,
                        propMap: { icon: "type" },
                      },
                      {
                        component: <SocialMediaV2.Handle />,
                        propMap: { link: "link" },
                      },
                    ],
                  },
                ]}
              />
            </SocialMediaV2>
            <BasicCarousel
              className={"image-gallery"}
              size={4}
              grouping={2}
              displayIndicators={true}
              displayPlayPauseButton={true}
              autoScroll={true}
              tablet={{}}
              mobile={{}}
              animation={{
                name: "blur",
                duration: 200,
                transitionProps: {
                  preAnimating: { opacity: 0.99, blur: "2px" },
                  animating: { opacity: 0.99, blur: "2px" },
                },
              }}
              items={componentIterator({
                iterator: getComponentFiles({
                  components: fishermanBusinessWebsitePage.components,
                  componentName: "ImageCollection",
                  componentIdentifier: "image_gallery",
                }),
                component: (
                  <Image background={true} className={"gallery-image-item"} />
                ),
                propMap: { src: "__all__" },
              })}
            />
          </div>
          <div className={"locations-page"}>
            <Grid
              stackable={true}
              textAlign={"center"}
              className={"locations-content-container"}
            >
              <Grid.Column width={16}>
                <div className={"locations-description"}>
                  Choose your Curl Evolution location, whether you are in
                  Babylon on Long Island's South Shore or in Dix Hills in the
                  heart of Huntington, and connect with a curl specialist ready
                  to work with your specific texture.
                </div>
                <WebsiteComponentInteractions
                  alignment={"center"}
                  ctas={getComponentInteractions({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "locations_description",
                  })}
                />
                <Card.Group itemsPerRow={3}>
                  <MultipleComponentIterator
                    iterator={allFishermanBusinessLocation.nodes}
                    components={[
                      {
                        component: (
                          <SlideReveal
                            className={"ui card"}
                            direction={"up"}
                            triggerOnce={true}
                            fade={true}
                          />
                        ),
                        propMap: { key: "street" },
                        children: [
                          {
                            component: (
                              <FullImageCard
                                as={InternalLink}
                                link={true}
                                event={{
                                  category: "Locations",
                                  action: "View Location Details",
                                }}
                              />
                            ),
                            propMap: {
                              "event.label": "name",
                              to: createLocationSlug,
                              image: withNamedArgs({
                                func: getBusinessFiles,
                                args: {
                                  businessFiles: allFishermanBusinessFile.nodes,
                                  numToSelect: 1,
                                  filesField: "featuredImage",
                                },
                              }),
                            },
                            children: [
                              {
                                component: <Header />,
                                children: [
                                  {
                                    component: <Conditional />,
                                    children: [
                                      {
                                        component: <Conditional.Condition />,
                                        propMap: {
                                          condition: "name",
                                          children: "name",
                                        },
                                      },
                                      {
                                        component: <Conditional.Condition />,
                                        propMap: {
                                          condition: "city",
                                          children: "city",
                                        },
                                      },
                                      {
                                        component: <Conditional.Default />,
                                        propMap: { children: "street" },
                                      },
                                    ],
                                  },
                                ],
                              },
                              {
                                component: <LocationName />,
                                propMap: { "address.street": "street" },
                              },
                              {
                                component: <LocationName />,
                                propMap: {
                                  "address.city": "city",
                                  "address.state": "state",
                                  "address.zip": "zipCode",
                                },
                              },
                              {
                                component: (
                                  <FishermanIcon
                                    iconName={"arrow-right"}
                                    className={"location-arrow-right"}
                                  />
                                ),
                              },
                            ],
                          },
                        ],
                      },
                    ]}
                  />
                </Card.Group>
              </Grid.Column>
            </Grid>
          </div>
          <div className={"reviews-section"}>
            <BasicCarousel
              size={3}
              displayIndicators={false}
              stepSize={1}
              autoScroll={false}
              displayPlayPauseButton={false}
              animation={{ name: "blur", duration: 160 }}
              items={multipleComponentIterator({
                iterator: fishermanBusiness.reviews,
                components: [
                  {
                    component: <ReviewV2 />,
                    propMap: { key: "_id" },
                    children: [
                      { component: <FishermanIcon iconName={"quote-left"} /> },
                      {
                        component: <ReviewV2.Text charLimit={360} />,
                        propMap: { text: "text" },
                      },
                      {
                        component: <ReviewV2.Line />,
                        children: [
                          {
                            component: <ReviewV2.Rating />,
                            propMap: { rating: "rating" },
                          },
                          {
                            component: <ReviewV2.RatingLabel />,
                            propMap: { rating: "rating" },
                          },
                        ],
                      },
                      {
                        component: <ReviewV2.Line />,
                        children: [
                          {
                            component: <ReviewV2.Author />,
                            propMap: { author: "author" },
                          },
                          {
                            component: <ReviewV2.Source />,
                            propMap: { source: "source", link: "link" },
                          },
                        ],
                      },
                    ],
                  },
                ],
              })}
            />
            <div className={"submit-review-button-container"}>
              <CustomerReviewModal
                businessId={fishermanBusiness._id}
                locations={allFishermanBusinessLocation.nodes}
                businessType={fishermanBusiness.type}
                buttonText={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "submit_review_button",
                  defaultValue: "Submit Review",
                })}
              />
            </div>
          </div>
          <div className={"blogs-section"}>
            <Header
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "blog_section_header",
                defaultValue: "LATEST ARTICLES",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "blog_section_description",
              })}
            />
            <Card.Group
              className={"featured-blogs"}
              itemsPerRow={2}
              stackable={true}
            >
              <MultipleComponentIterator
                iterator={allFishermanBusinessBlogPost.nodes}
                limit={2}
                components={[
                  {
                    component: <HorizontalImageCard imagePosition={"left"} />,
                    propMap: { key: "_id", image: "gatsbyHeroImage" },
                    children: [
                      {
                        component: <BlogPostLink />,
                        propMap: { key: "_id", slug: "slug", title: "title" },
                        children: [
                          {
                            component: <Card.Header className={"title"} />,
                            propMap: { content: "title" },
                          },
                          {
                            component: <FormattedDate outputFormat={"PPP"} />,
                            propMap: { date: "publishedAt" },
                          },
                          {
                            component: (
                              <ExpandableText
                                charLimit={160}
                                disableExpanding={true}
                              />
                            ),
                            propMap: { text: "summary" },
                          },
                          {
                            component: (
                              <FishermanIcon iconName={"arrow-right"} />
                            ),
                          },
                        ],
                      },
                    ],
                  },
                ]}
              />
            </Card.Group>
            <WebsiteComponentInteractions
              alignment={"center"}
              ctas={getComponentInteractions({
                components: fishermanBusinessWebsitePage.components,
                componentId: "blog_section_description",
              })}
              fallback={
                <React.Fragment>
                  <Button
                    to={"/blog/"}
                    primary={true}
                    as={InternalLink}
                    event={{ category: "Blog", action: "View All Blog Posts" }}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "see_all_articles_button",
                      defaultValue: "See All Articles",
                    })}
                  />
                </React.Fragment>
              }
            />
          </div>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      socialMedia {
        _id
        link
        type
      }
      reviews {
        _id
        author
        text
        source
        rating
        link
      }
      _id
      type
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        contentNodes {
          content
        }
        interactions {
          _id
          order
          behaviorType
          displayType
          enabled
          label
          style
          url
          role
        }
      }
      seoTitle
      seoOgImage {
        url
        alt
        type
      }
    }
    dynamicTilesComponent: fishermanWebsiteComponent(
      page: { pageType: { eq: "Home" } }
      fastId: { eq: "DynamicTiles" }
    ) {
      childConfigurations {
        data {
          className
          overlayClassName
          width
          video {
            videoId
            url
            source
            placeholder
          }
        }
        files {
          _id
          altText
          file
          order
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        contentNodes {
          _id
          content
          contentType
          contentName
          order
        }
        interactions {
          _id
          displayType
          behaviorType
          enabled
          label
          order
          style
          url
        }
      }
    }
    allFishermanBusinessTeam(
      sort: { order: ASC, fields: order }
      filter: { show: { eq: true } }
    ) {
      nodes {
        _id
        name
        role
        group
        email
        phone
        description
        image
        gatsbyImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        socialMedia {
          platform
          url
        }
        hours {
          startDay
          openTime
          closeTime
        }
        locations {
          _id
          name
        }
        show
      }
    }
    allFishermanBusinessLocation {
      nodes {
        _id
        street
        city
        state
        zipCode
        name
        featuredImage
        phoneNumber
        primaryLocation
      }
    }
    allFishermanBusinessFile {
      nodes {
        _id
        file
        description
        gatsbyFile {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
    }
    allFishermanBusinessBlogPost(filter: { destination: { eq: "BLOG" } }) {
      nodes {
        _id
        title
        slug
        author {
          firstName
          lastName
          avatar
          email
        }
        summary
        content
        heroImage
        gatsbyHeroImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        publishedAt
      }
    }
  }
`;
